module.exports = {
  server_url: "https://dietly.pl",
  //WERSJA DEWELOPERSKA LOKALNIE:
  // server_url: "https://dietlydev001front.herokuapp.com",
  // companyId: "crmdev1",
  // apiKey: "1adc2779-69e6-4ccf-84ae-7486b391e36b",
};
